// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-footer[data-v-e911d228]{margin:1.75rem 1.5rem 2rem;display:flex;flex-direction:column;align-items:stretch}@media (min-width:1024px){.l-footer[data-v-e911d228]{align-items:center}}@media (min-width:1024px){.l-footer[data-v-e911d228] button{min-width:288px}}.l-actions[data-v-e911d228]{display:flex;flex-direction:column;gap:1rem}@media (min-width:1024px){.l-actions[data-v-e911d228]{flex-direction:row-reverse}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
